// extracted by mini-css-extract-plugin
export default {"card":"ApplicationCards_card__5K8FC","header":"ApplicationCards_header__DOlbT","content":"ApplicationCards_content__Q8JPs","footer":"ApplicationCards_footer__vzgsi"};